import * as React from 'react';
import { Link } from 'react-router';

import Pagination from "react-js-pagination";

import NewsCategory from '../../api/newsCategoryEntity';
import TopicItemDto from '../../api/topicItemDto';
import TopicListItemsDto from '../../api/topicListItemsDto';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';

interface IProps {
    categoriesFilter: string;
    topicListItemsDto: TopicListItemsDto;
    newsEventCategories: NewsCategory[];
    fetchTopicItems(query?: object): void;
    fetchTopicItemsCategories(): void;
    fetchTopicItemsByCategory(categories: string, query?: object): void;
}

export class TopicItemsListPage extends React.Component<IProps,{itemsOnPage: number}> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            itemsOnPage: 10
        };

        this.handlePageChange = this.handlePageChange.bind(this);
    }

  public componentDidMount() {
    this.props.fetchTopicItemsCategories();

    if (!this.props.categoriesFilter) {
      this.props.fetchTopicItems({ limit: this.state.itemsOnPage });
    } else {
      this.fetchByFilter(this.props.categoriesFilter, 0);
    }
  }

   public componentDidUpdate(prevProps: IProps) {
     if (prevProps.categoriesFilter !== this.props.categoriesFilter) {
       this.fetchByFilter(this.props.categoriesFilter, 0);
     }
     if (prevProps.newsEventCategories.length === 0 && this.props.newsEventCategories.length > 0 && this.props.categoriesFilter) {
       this.fetchByFilter(this.props.categoriesFilter, 0);
     }
   }

  public handlePageChange = (page: number) => {
    const skip = this.state.itemsOnPage * (page - 1);
    this.fetchByFilter(this.props.categoriesFilter, skip);
  };

  public render() {
      let cssClassName = "";

      if (window.location.href.indexOf("ajankohtaista/") === -1) {
          cssClassName = "active";
      }

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h1>Kaikki ajankohtaiset</h1>
                        <div className="categories">
                            <b>Suodata aiheen mukaan</b>
                            <div className="categories-list">
                                <ul id="taglist">
                                    <li><Link className={cssClassName} to={"/ajankohtaista"}>Kaikki</Link></li>
                                    {this.props.newsEventCategories && this.props.newsEventCategories.map(NewsCategoryItem)}
                                </ul>
                            </div>

                       </div>
                        <ul className="newslisting">
                        {this.props.topicListItemsDto.topicItems.map(TopicItem)}
                        </ul>
                        <Pagination
                            activePage={this.props.topicListItemsDto.skip / this.state.itemsOnPage + 1}
                            itemsCountPerPage={this.props.topicListItemsDto.limit}
                            totalItemsCount={this.props.topicListItemsDto.total}
                            pageRangeDisplayed={3}
                            onChange={this.handlePageChange}
                            />
                    </div>
                </div>
            </div>
        </main>
    );
  }


  private fetchByFilter(slug: string | undefined, skip: number) {
    if (this.props.newsEventCategories.length === 0) {
        return;
    }

    if (!slug) {
      this.props.fetchTopicItems({ limit: this.state.itemsOnPage, skip });
      return;
    }

    const friendly = '/' + slug;
    const hit = this.props.newsEventCategories.find(c => c.friendlyUrl === friendly);
    if (hit) {
      this.props.fetchTopicItemsByCategory(hit.id, { limit: this.state.itemsOnPage, skip });
    }
  }

};

const TopicItem = (newsItem: TopicItemDto) => {
    return (
        <li>
            {newsItem.type === "eventPage" && 
                <Link to={`/tapahtumat${newsItem.id}`} className="box-inner-wrap" tabIndex={-1}><span className="tag-page">Tapahtuma</span><span className="tag-page-text">{newsItem.title}</span></Link>
            }
            {newsItem.type === "newsPage" && 
                <Link to={`/uutiset${newsItem.id}`} className="box-inner-wrap" tabIndex={-1}><span className="tag-page news">Uutinen</span><span className="tag-page-text">{newsItem.title}</span></Link>
            }
        </li>
    )
}

const NewsCategoryItem = (newsCategory: NewsCategory) => {
    let cssClassName = "";

    if (window.location.href.indexOf(newsCategory.friendlyUrl) !== -1) {
        cssClassName = "active";
    }
    return (
      <li>
        <Link className={cssClassName} to={`/ajankohtaista${newsCategory.friendlyUrl}`}>{newsCategory.title}</Link>
      </li>
    )
}


// WEBPACK FOOTER //
// ./src/components/newsListPage/newsListPage.tsx